// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <button
        class="MuiButtonBase-root MuiButton-root makeStyles-button-1 MuiButton-outlined MuiButton-outlinedSecondary MuiButton-disableElevation"
        tabindex="0"
        type="button"
      >
        <span
          class="MuiButton-label"
        >
          Find Patient
        </span>
        <span
          class="MuiTouchRipple-root"
        />
      </button>
      <div
        class="MuiCollapse-container MuiCollapse-hidden"
        style="min-height: 0px;"
      >
        <div
          class="MuiCollapse-wrapper"
        >
          <div
            class="MuiCollapse-wrapperInner"
          >
            <div
              class="MuiPaper-root MuiAlert-root makeStyles-alert-2 MuiAlert-standardError MuiPaper-elevation0"
              role="alert"
            >
              <div
                class="MuiAlert-message"
              >
                <p
                  class="MuiTypography-root MuiTypography-body1 MuiTypography-colorInherit"
                >
                   
                  
                   
                </p>
              </div>
              <div
                class="MuiAlert-action"
              >
                <button
                  aria-label="close"
                  class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeSmall"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiIconButton-label"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                      />
                    </svg>
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        class="MuiBackdrop-root makeStyles-backDrop-3"
        style="opacity: 0; visibility: hidden;"
      >
        <div
          class="MuiCircularProgress-root MuiCircularProgress-colorPrimary MuiCircularProgress-indeterminate"
          role="progressbar"
          style="width: 40px; height: 40px;"
        >
          <svg
            class="MuiCircularProgress-svg"
            viewBox="22 22 44 44"
          >
            <circle
              class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate"
              cx="44"
              cy="44"
              fill="none"
              r="20.2"
              stroke-width="3.6"
            />
          </svg>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <button
      class="MuiButtonBase-root MuiButton-root makeStyles-button-1 MuiButton-outlined MuiButton-outlinedSecondary MuiButton-disableElevation"
      tabindex="0"
      type="button"
    >
      <span
        class="MuiButton-label"
      >
        Find Patient
      </span>
      <span
        class="MuiTouchRipple-root"
      />
    </button>
    <div
      class="MuiCollapse-container MuiCollapse-hidden"
      style="min-height: 0px;"
    >
      <div
        class="MuiCollapse-wrapper"
      >
        <div
          class="MuiCollapse-wrapperInner"
        >
          <div
            class="MuiPaper-root MuiAlert-root makeStyles-alert-2 MuiAlert-standardError MuiPaper-elevation0"
            role="alert"
          >
            <div
              class="MuiAlert-message"
            >
              <p
                class="MuiTypography-root MuiTypography-body1 MuiTypography-colorInherit"
              >
                 
                
                 
              </p>
            </div>
            <div
              class="MuiAlert-action"
            >
              <button
                aria-label="close"
                class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeSmall"
                tabindex="0"
                type="button"
              >
                <span
                  class="MuiIconButton-label"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                  </svg>
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="MuiBackdrop-root makeStyles-backDrop-3"
      style="opacity: 0; visibility: hidden;"
    >
      <div
        class="MuiCircularProgress-root MuiCircularProgress-colorPrimary MuiCircularProgress-indeterminate"
        role="progressbar"
        style="width: 40px; height: 40px;"
      >
        <svg
          class="MuiCircularProgress-svg"
          viewBox="22 22 44 44"
        >
          <circle
            class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate"
            cx="44"
            cy="44"
            fill="none"
            r="20.2"
            stroke-width="3.6"
          />
        </svg>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
